@reference "@glow/tailwind-config/reference.css";

.wrap table {
  @apply w-full;
  border-collapse: collapse;
  border-spacing: 0 0;
  @apply text-emphasis-medium;
}

.shadow {
  @apply shadow-light;
}

.wrap th {
  @apply p-2;
  @apply text-xs;
  @apply font-bold;
}

.wrap td {
  @apply h-10;
  @apply px-2;
  /* Leaves room for a 32px control and half of the collapsed row border within the 40px row */
  @apply py-0.5;
  @apply text-ellipsis;
  @apply text-sm;
}

.wrap thead {
  @apply h-12;
}

.wrap thead tr {
  @apply shadow-light;
  @apply h-8;
}

.wrap th,
.wrap tfoot td {
  @apply text-left;
  @apply align-middle;
}

.wrap tfoot td {
  @apply font-semibold;
  @apply whitespace-nowrap;
}

.wrap .stickyHeaders tfoot,
.wrap .stickyHeaders thead {
  @apply sticky;
  @apply z-10;
}

.wrap .stickyHeaders tfoot {
  @apply -bottom-[1px];
}
.wrap .stickyHeaders thead {
  @apply -top-[1px];
}

.wrap thead th {
  @apply bg-gray-200;
}

.wrap tfoot th,
.wrap tfoot td {
  @apply bg-gray-100;
}

.wrap th:first-child {
  @apply border-l;
  @apply rounded-l;
}

.wrap th:last-child {
  @apply border-r;
  @apply rounded-r;
}

.wrap tr:not(:last-child) {
  @apply border-solid;
  @apply border-0;
  @apply border-b;
  @apply border-gray-200;
}
